//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { MOBILE } from '@/scripts/constants/media-query'

export default {
  name: 'common-modal',
  props: {
    closeIconMobile: {
      type: String,
      default: 'close-bold',
    },
    title: {
      type: String,
      default: '',
    },
    id: {
      type: String,
      default: '',
    },
    className: {
      type: String,
      default: '',
    },
  },
  computed: {
    closeIconMobileClass() {
      return `common__icon common__icon--${this.closeIconMobile}`
    },
    isMobile() {
      return this.$mq === MOBILE
    },
  },
}
